import { render, staticRenderFns } from "./ThumbsButtons.vue?vue&type=template&id=176ed467&scoped=true&"
import script from "./ThumbsButtons.vue?vue&type=script&lang=ts&"
export * from "./ThumbsButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ed467",
  null
  
)

export default component.exports